const Main = r =>
  require.ensure([], () => r(require("@/components/Main")), "Main");

const Empty = r =>
  require.ensure([], () => r(require("@/components/Empty")), "");

// 账户中心
const Account = r =>
  require.ensure(
    [],
    () => r(require("@/components/account/Account")),
    "Account"
  );

// 账户中心 -- 银票快贴 -- 贴现账户及银行签约管理
const SilverTicketManage = r =>
  require.ensure(
    [],
    () => r(require("@/components/account/SilverTicketManage")),
    "SilverTicketManage"
  );

// 账户中心 -- 快贴代理人 -- 我的佣金
const Commission = r =>
  require.ensure(
    [],
    () => r(require("@/components/account/Commission")),
    "Commission"
  );

export const accountRouter = [
  {
    path: "/DiscountTrends",
    component: Main,
    meta: {
      url: "/DiscountTrends",
      activeType: "05",
      login: true
    },
    children: [
      {
        path: "/",
        component: Account,
        children: [
          {
            path: "/",
            component: r =>
              require.ensure(
                [],
                () => r(require("@/components/account/DiscountTrends")),
                "DiscountTrends"
              ),
            name: "DiscountTrends",
            meta: {
              name: "账户动态",
              icon: "ios-folder",
              url: "/DiscountTrends",
              activeType: "05",
              login: true
            }
          },
          {
            path: "/SilverTicket",
            component: Empty,
            meta: {
              name: "银票快贴",
              icon: "ios-folder",
              url: "/SilverTicket",
              progress: 2,
              activeType: "05",
              login: true
            },
            children: [
              {
                path: "/", // 账户中心 -- 银票快贴 -- 进行中的订单
                component: r =>
                  require.ensure(
                    [],
                    () => r(require("@/components/account/SilverTicket")),
                    "SilverTicket"
                  ),
                name: "SilverTicket",
                meta: {
                  name: "进行中的订单",
                  icon: "ios-paper",
                  url: "/SilverTicket",
                  progress: 2,
                  activeType: "05",
                  login: true
                }
              },
              {
                path: "/SilverTicketFinish", // 账户中心 -- 银票快贴 -- 已完成的订单
                component: r =>
                  require.ensure(
                    [],
                    () => r(require("@/components/account/SilverTicketFinish")),
                    "SilverTicketFinish"
                  ),
                name: "SilverTicketFinish",
                meta: {
                  name: "已完成的订单",
                  icon: "ios-paper",
                  url: "/SilverTicketFinish",
                  progress: 2,
                  activeType: "05",
                  login: true
                }
              },
              {
                path: "/SilverTicketManage",
                component: SilverTicketManage,
                meta: {
                  name: "贴现账户及银行签约管理",
                  icon: "ios-paper",
                  url: "/SilverTicketManage",
                  progress: 2,
                  activeType: "05",
                  login: true
                }
              }
            ]
          },
          {
            path: "/ProceedOrder",
            component: Empty,
            meta: {
              name: "商票速融",
              icon: "ios-folder",
              url: "/ProceedOrder",
              progress: 8,
              activeType: "06",
              login: true
            },
            children: [
              {
                path: "/", // 账户中心 -- 商票速融 -- 进行中的订单
                component: r =>
                  require.ensure(
                    [],
                    () => r(require("@/components/account/ProceedOrder")),
                    "ProceedOrder"
                  ),
                meta: {
                  name: "进行中的订单",
                  icon: "ios-paper",
                  url: "/ProceedOrder",
                  progress: 8,
                  activeType: "06",
                  login: true
                }
              },
              {
                path: "/FinishedOrder", // 账户中心 -- 商票速融 -- 已完成的订单
                component: r =>
                  require.ensure(
                    [],
                    () => r(require("@/components/account/FinishedOrder")),
                    "FinishedOrder"
                  ),
                meta: {
                  name: "已完成的订单",
                  icon: "ios-paper",
                  url: "/FinishedOrder",
                  progress: 8,
                  activeType: "06",
                  login: true
                }
              },
              {
                path: "/AccountManage",
                component: r =>
                  require.ensure(
                    [],
                    () => r(require("@/components/account/AccountManage")),
                    "AccountManage"
                  ), // 账户中心 -- 商票速融 -- 贴现账户管理
                meta: {
                  name: "贴现账户管理",
                  icon: "ios-paper",
                  url: "/AccountManage",
                  progress: 8,
                  activeType: "06",
                  login: true
                }
              }
            ]
          },
          /* {
            path: '/ServiceChargeManage',
            component: Empty,
            meta: {
              name: "服务费管理",
              icon: "ios-folder",
              url: '/ServiceChargeManage',
              progress: 3,
              activeType: "05",
              login: true,
            },
            children:[
              {
                path: '/',
                component: r => require.ensure([], () => r(require('@/components/account/ServiceChargeManage')), 'ServiceChargeManage'), // 账户中心 -- 服务费管理 -- 开具发票
                name: 'ServiceChargeManage',
                meta: {
                  name: "开具发票",
                  icon: "ios-paper",
                  url: '/ServiceChargeManage',
                  progress: 3,
                  activeType: "05",
                  login: true,
                },
              },
              {
                path: '/ServiceChargeDetail',
                component: r => require.ensure([], () => r(require('@/components/account/ServiceChargeDetail')), 'ServiceChargeDetail'),// 账户中心 -- 服务费管理 -- 明细
                name: 'ServiceChargeDetail',
                meta: {
                  name: "明细",
                  icon: "ios-paper",
                  url: '/ServiceChargeDetail',
                  progress: 3,
                  activeType: "05",
                  login: true,
                },
              },
              {
                path: '/RechargeServiceCharge',
                component: SilverTicketManage,
                meta: {
                  name: "充值服务费",
                  icon: "ios-paper",
                  url: '/RechargeServiceCharge',
                  progress: 3,
                  activeType: "05",
                  login: true,
                  noUrl: true, // 使用路由守卫控制不进行跳转
                  event: "recharge", // 调用的事件的名字：recharge：展示充值弹框
                },
              },
            ]
          }, */
          /* {
            path: "/ElectronicDepositList",
            component: Empty,
            meta: {
              name: "电子存款",
              icon: "ios-folder",
              url: "/ElectronicDepositList",
              progress: 4,
              activeType: "06",
              login: true
            },
            children: [
              {
                path: "/", // 账户中心 -- 电子存款 -- 订单管理
                component: r =>
                  require.ensure(
                    [],
                    () =>
                      r(
                        require("@/view/ElectronicDeposit/ElectronicDepositList")
                      ),
                    "ElectronicDepositList"
                  ),
                meta: {
                  name: "订单管理",
                  icon: "ios-paper",
                  url: "/ElectronicDepositList",
                  progress: 4,
                  activeType: "06",
                  login: true
                }
              },
              {
                path: "/ElectronicDepositAccount", // 账户中心 -- 电子存款 -- 账户管理
                name: "ElectronicDepositAccount",
                component: r =>
                  require.ensure(
                    [],
                    () =>
                      r(
                        require("@/view/ElectronicDeposit/ElectronicDepositAccount")
                      ),
                    "ElectronicDepositAccount"
                  ),
                meta: {
                  name: "账户管理",
                  icon: "ios-paper",
                  url: "/ElectronicDepositAccount",
                  progress: 4,
                  activeType: "06",
                  login: true
                }
              }
            ]
          }, */
          {
            path: "/UserInfoChange",
            component: Empty,
            meta: {
              name: "我的快贴宝",
              icon: "ios-folder",
              url: "/UserInfoChange",
              progress: 7,
              activeType: "05",
              login: true
            },
            children: [
              {
                path: "/",
                component: r =>
                  require.ensure(
                    [],
                    () => r(require("@/components/account/UserInfoChange")),
                    "UserInfoChange"
                  ),
                meta: {
                  name: "用户信息修改",
                  icon: "ios-paper",
                  url: "/UserInfoChange",
                  progress: 7,
                  activeType: "05",
                  login: true
                }
              },
              {
                path: "/ChangePwd",
                component: Commission,
                meta: {
                  name: "更改登录密码",
                  icon: "ios-paper",
                  url: "/ChangePwd",
                  progress: 7,
                  activeType: "05",
                  login: true,
                  noUrl: true, // 使用路由守卫阻止路由跳转，使用noUrl的名称进行导航的name绑定
                  event: "password" // 调用的事件的名字：recharge：展示充值弹框；password：展示更改密码弹框
                }
              }
            ]
          },
          {
            path: "/Popularize",
            component: Empty,
            meta: {
              name: "快贴代理人",
              icon: "ios-folder",
              url: "/Popularize",
              progress: 6,
              activeType: "05",
              login: true
            },
            children: [
              {
                path: "/",
                component: r =>
                  require.ensure(
                    [],
                    () => r(require("@/components/account/Popularize")),
                    "Popularize"
                  ), // 账户中心 -- 快贴代理人 -- 我的推广
                meta: {
                  name: "我的推广",
                  icon: "ios-paper",
                  url: "/Popularize",
                  progress: 6,
                  activeType: "05",
                  login: true
                }
              },
              {
                path: "/Commission",
                component: Commission,
                meta: {
                  name: "我的佣金",
                  icon: "ios-paper",
                  url: "/Commission",
                  progress: 6,
                  activeType: "05",
                  login: true
                }
              }
            ]
          }
        ]
      },
      {
        path: "/OpenAnAccount", // 京东开户申请
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/account/OpenAnAccount")),
            "OpenAnAccount"
          ),
        name: "OpenAnAccount",
        meta: {
          name: "京东开户申请",
          icon: "ios-paper",
          url: "/OpenAnAccount",
          progress: 2,
          activeType: "05",
          login: true
        }
      },
      {
        path: "/BankAgreement",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/account/BankAgreement")),
            "BankAgreement"
          ),
        name: "BankAgreement",
        meta: {
          name: "银行签约",
          icon: "ios-paper",
          url: "/BankAgreement",
          progress: 2,
          activeType: "05",
          login: true
        }
      },
      {
        path: "/BankAgreementCommon",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/account/BankAgreementCommon")),
            "BankAgreementCommon"
          ),
        name: "BankAgreementCommon",
        meta: {
          name: "银行签约",
          icon: "ios-paper",
          url: "/BankAgreementCommon",
          progress: 2,
          activeType: "05",
          login: true
        }
      },
      {
        path: "/BankAgreementIntegrate",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/account/BankAgreementIntegrate")),
            "BankAgreementIntegrate"
          ),
        name: "BankAgreementIntegrate",
        meta: {
          name: "银行签约",
          icon: "ios-paper",
          url: "/BankAgreementIntegrate",
          progress: 2,
          activeType: "05",
          login: true
        }
      },
      
      {
        path: "/OpenBizAccount", // 商票开户申请
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/account/OpenBizAccount")),
            "OpenBizAccount"
          ),
        name: "OpenBizAccount",
        meta: {
          name: "京东开户申请",
          icon: "ios-paper",
          url: "/OpenBizAccount",
          progress: 2,
          activeType: "05",
          login: true
        }
      },
      {
        path: "/OpenElectronicDepositAccount", // 存款开户申请
        component: r =>
          require.ensure(
            [],
            () =>
              r(
                require("@/view/ElectronicDeposit/OpenElectronicDepositAccount")
              ),
            "OpenElectronicDepositAccount"
          ),
        name: "OpenElectronicDepositAccount",
        meta: {
          name: "京东开户申请",
          icon: "ios-paper",
          url: "/OpenElectronicDepositAccount",
          progress: 2,
          activeType: "05",
          login: true
        }
      }
    ]
  }
];

export const discountRateRouter = [
  {
    path: "/",
    component: Main,
    children: [
      {
        path: "DiscountRate",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/discountRate/DiscountRate")),
            "DiscountRate"
          ),
        meta: {
          name: "贴现利率表"
        }
      }
    ]
  }
];

export const LandingPageRouter = [
  {
    path: "/",
    component: r =>
      require.ensure(
        [],
        () => r(require("@/view/BrowserRedirect")),
        "BrowserRedirect"
      ), // 响应式页面或协议外框
    children: [
      {
        path: "web",
        component: Empty,
        children: [
          {
            path: "KtbTrio",
            component: r =>
              require.ensure(
                [],
                () => r(require("@/components/activity/KtbTrio")),
                "KtbTrio"
              ),
            meta: {
              name: "快贴宝三重奏"
            }
          },
          {
            path: "AgentInvite-:id",
            name: "AgentInviteWeb",
            component: r =>
              require.ensure(
                [],
                () =>
                  r(
                    require("@/components/activity/DiscountAgentInvite/PC.vue")
                  ),
                "202012"
              ),
            meta: {
              name: "注册推广页面"
            }
          }
        ]
      },
      {
        path: "app",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/activity/APPView")),
            "APPView"
          ), // 活动页公共外框
        children: [
          {
            path: "KtbTrio",
            component: r =>
              require.ensure(
                [],
                () => r(require("@/components/activity/KtbTrioMin")),
                "KtbTrioMin"
              ),
            meta: {
              name: "快贴宝三重奏"
            }
          },
          {
            path: "AgentInvite-:id",
            name: "AgentInviteApp",
            component: r =>
              require.ensure(
                [],
                () =>
                  r(
                    require("@/components/activity/DiscountAgentInvite/DiscountAgentInviteApp.vue")
                  ),
                "DiscountAgentInviteMin"
              ),
            meta: {
              name: "注册推广页面"
            }
          }
        ]
      }
    ]
  }
];

export const otherRouter = [
  {
    path: "/",
    component: Main,
    children: [
      {
        path: "PlatformIntroduce",
        component: r =>
          require.ensure(
            [],
            () =>
              r(require("@/components/platformIntroduce/PlatformIntroduce")),
            "PlatformIntroduce"
          ),
        meta: {
          name: "平台介绍",
          title: "产品介绍-快贴宝"
        }
      },
      {
        path: "download",
        component: r =>
          require.ensure([], () => r(require("@/view/download")), "download"),
        meta: {
          name: "APP下载",
          title: "APP下载-快贴宝"
        }
      },
      {
        path: "Help",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/help/Help")),
            "help"
          ),
        meta: {
          name: "帮助中心",
          title: "帮助中心-快贴宝"
        },
        children: [
          {
            path: "/",
            component: r =>
              require.ensure(
                [],
                () => r(require("@/components/help/HelpIndex")),
                "HelpIndex"
              ),
            meta: {
              name: "帮助中心",
              title: "帮助中心-快贴宝"
            }
          },
          {
            path: "Detail/:id(\\d+)", // 正则匹配 id 必须是数字
            component: r =>
              require.ensure(
                [],
                () => r(require("@/components/help/HelpDetail")),
                "HelpDetail"
              ),
            name: "Detail",
            meta: {
              name: "帮助中心详情页"
            }
          }
        ]
      },
      {
        path: "Information",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/information/InformationIndex")),
            "InformationIndex"
          ),
        meta: {
          name: "资讯",
          title: "行业资讯-快贴宝"
        }
      },
      {
        path: "InformationDetail", // 正则匹配 id 必须是数字
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/information/InformationDetail")),
            "InformationDetail"
          ),
        name: "InformationDetail",
        meta: {
          name: "资讯详情页"
        }
      },
      {
        path: "Notice",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/notice/Notice")),
            "Notice"
          ),
        meta: {
          name: "公告",
          title: "公告中心-快贴宝"
        },
        children: [
          {
            path: "/",
            component: r =>
              require.ensure(
                [],
                () => r(require("@/components/notice/NoticeIndex")),
                "NoticeIndex"
              ),
            meta: {
              name: "公告",
              title: "公告中心-快贴宝"
            }
          },
          {
            path: "Detail", // 正则匹配 id 必须是数字
            component: r =>
              require.ensure(
                [],
                () => r(require("@/components/notice/NoticeDetail")),
                "NoticeDetail"
              ),
            name: "NoticeDetail",
            meta: {
              name: "公告详情页"
            }
          }
        ]
      },
      {
        path: "redirect/jd-piaoju", // 重定向京东票据页面
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/redirect/JdPiaojuRedirect")),
            "JdPiaojuRedirect"
          ),
        name: "InformationDetail",
        meta: {
          name: "资讯详情页"
        }
      }
    ]
  },

  // 响应式、协议页面
  {
    path: "/",
    component: r =>
      require.ensure(
        [],
        () => r(require("@/components/activity/NormalPage")),
        "NormalPage"
      ), // 响应式页面或协议外框
    children: [
      {
        path: "KtbForm",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/activity/KtbForm")),
            "KtbForm"
          ),
        meta: {
          name: "申请搭建银行快贴平台服务"
        }
      },
      {
        path: "KtbIntroduce",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/activity/KtbIntroduce")),
            "KtbIntroduce"
          ),
        meta: {
          name: "快贴宝搭建服务介绍"
        }
      },
      {
        path: "JuneRecharge",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/activity/JuneRecharge")),
            "JuneRecharge"
          ),
        meta: {
          name: "燃情六月，充值送送送"
        }
      },
      {
        path: "ZBActivity",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/activity/ZBActivity")),
            "ZBActivity"
          ),
        meta: {
          name: "众邦上线活动"
        }
      },
      // {
      //   path: "ZCXYApp",
      //   component: r =>
      //     require.ensure(
      //       [],
      //       () => r(require("@/components/activity/ZCXYApp")),
      //       "ZCXYApp"
      //     ),
      //   meta: {
      //     name: "app注册协议"
      //   }
      // },
      {
        path: "YSXYApp",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/activity/YSXYApp")),
            "YSXYApp"
          ),
        meta: {
          name: "app隐私协议"
        }
      },
      {
        path: "AcctCancellationXY",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/activity/AcctCancellationXY")),
            "AcctCancellationXY"
          ),
        meta: {
          name: "账户注销协议"
        }
      },
      {
        path: "discount-api/to-credit",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/externalPage/BankSign")),
            "BankSign"
          ),
        name: "BankSign",
        meta: {
          name: "银行签约对外"
        }
      },
      {
        path: "ExternalPrivacyAgree",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/externalPage/ExternalPrivacyAgree")),
            "ExternalPrivacyAgree"
          ),
        name: "ExternalPrivacyAgree",
        meta: {
          name: "对外协议"
        }
      }
    ]
  },

  // PC端对应的活动页
  {
    path: "/",
    component: Empty,
    children: [
      {
        path: "KtbPopularize", // 快贴包红包领取规则
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/activity/KtbPopularize")),
            "KtbPopularize"
          ),
        meta: {
          name: "快贴宝推广页"
        }
      },
      {
        path: "KtbConsociation", // 买化塑
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/activity/KtbConsociation")),
            "KtbConsociation"
          ),
        meta: {
          name: "买化塑&快贴宝合作"
        }
      },
      {
        path: "KtbTrio",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/activity/KtbTrio")),
            "KtbTrio"
          ),
        meta: {
          name: "快贴宝三重奏"
        }
      },
      {
        path: "BankInfo", // 什么是“快贴宝网商银行贴” - web
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/activity/MYBANK/BankInfo")),
            "BankInfo"
          ),
        meta: {
          name: "在线票据快贴服务"
        }
      },
      {
        path: "WZBankPC", // 微众银行---PC
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/activity/WZBankPC")),
            "WZBankPC"
          ),
        meta: {
          name: "快贴宝"
        }
      },
      {
        path: "SPSRWeb",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/activity/SPSRWeb")),
            "SPSRWeb"
          ),
        meta: {
          name: "商票速融"
        }
      },
      {
        path: "202012",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/activity/202012/PC.vue")),
            "202012"
          ),
        meta: {
          name: "2020年末大礼"
        }
      },
      {
        path: "/DiscountRateWeb", // 利率-PC端页面
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/discountRate/DiscountRateWeb")),
            "DiscountRateWeb"
          ),
        name: "DiscountRateWeb"
      }
    ]
  },

  // 移动端对应的活动页
  {
    path: "/",
    component: r =>
      require.ensure(
        [],
        () => r(require("@/components/activity/APPView")),
        "APPView"
      ), // 活动页公共外框
    children: [
      {
        path: "BankRegister/:id?", // 网商银行注册-app
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/activity/MYBANK/BankRegister")),
            "BankRegister"
          ),
        meta: {
          name: "在线票据快贴服务"
        }
      },
      {
        path: "BankSuccess", // 网商银行注册成功页-app
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/activity/MYBANK/BankSuccess")),
            "BankSuccess"
          ),
        meta: {
          name: "在线票据快贴服务"
        }
      },
      {
        path: "BankInfoMin", // 什么是“快贴宝网商银行贴” - app
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/activity/MYBANK/BankInfoMin")),
            "BankInfoMin"
          ),
        meta: {
          name: "在线票据快贴服务"
        }
      },
      {
        path: "KtbTrioMin",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/activity/KtbTrioMin")),
            "KtbTrioMin"
          ),
        meta: {
          name: "快贴宝三重奏"
        }
      },
      {
        path: "KtbPlatformInfoMin",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/activity/KtbPlatformInfoMin")),
            "KtbPlatformInfoMin"
          ),
        meta: {
          name: "平台介绍"
        }
      },
      {
        path: "SignContract",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/account/SignContract/index")),
            "SignContract"
          ),
        meta: {
          name: "签约账户"
        }
      },
      {
        path: "WZBankMin", // 微众银行---H5
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/activity/WZBankMin")),
            "WZBankMin"
          ),
        meta: {
          name: "快贴宝"
        }
      },
      {
        path: "202012min",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/activity/202012/H5.vue")),
            "202012"
          ),
        meta: {
          name: "2020年末大礼"
        }
      },
      {
        path: "SPSRMin",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/activity/SPSRMin")),
            "SPSRMin"
          ),
        name: 'SPSRMin',
        meta: {
          name: "商票速融"
        }
      },
      {
        path: "DiscountRatewap", // 利率-移动端页面
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/discountRate/DiscountRateWap")),
            "DiscountRatewap"
          ),
        name: "DiscountRatewap",
        meta: {
          name: "贴现行情"
        }
      },
      {
        path: "BankAgreementInner", // 银行签约内嵌页
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/account/BankAgreementInner")),
            "BankAgreementInner"
          ),
        name: "BankAgreementInner",
        meta: {
          name: "银行签约",
          url: "/BankAgreementInner",
        }
      },
      {
        path: "BankAgreementCredit", // 银行签约内嵌页
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/account/BankAgreementCredit")),
            "BankAgreementCredit"
          ),
        name: "BankAgreementCredit",
        meta: {
          name: "银行签约",
          url: "/BankAgreementCredit",
        }
      },
    ]
  }
];

export const emptyRouter = [
  {
    path: "/seo",
    component: r =>
      require.ensure([], () => r(require("@/components/seo/index")), "seo"),
    meta: {
      name: "SEO备案"
    }
  }
];

export const mainRouter = [
  {
    path: "/",
    component: Main,
    children: [
      {
        path: "",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/home/Home")),
            "Home"
          ),
        name: "Home",
        meta: {
          name: "首页",
          activeType: "01",
          url: "/",
          title: "快贴宝-银行承兑汇票贴现「实时利率」最新电子承兑汇票贴息",
          keywords: "承兑汇票贴现,银行承兑汇票,电子承兑汇票",
          description:
            "快贴宝-提供实时银行承兑汇票贴现利率查询，是安全专业的线上电子承兑汇票贴现服务平台，可在线多家银行签约、无需实地开户，跨行贴现、快速匹配最优银行！"
        }
      },
      {
        path: "/ApplicationDiscount",
        component: r =>
          require.ensure(
            [],
            () =>
              r(
                require("@/components/applicationDiscount/ApplicationDiscount")
              ),
            "ApplicationDiscount"
          ),
        name: "ApplicationDiscount",
        meta: {
          name: "银票快贴",
          activeType: "02",
          url: "/ApplicationDiscount",
          title: "银票快贴-快贴宝"
        }
      },
      {
        path: "/DiscountRate",
        component: r =>
          require.ensure(
            [],
            () => r(require("@/components/discountRate/DiscountRate")),
            "DiscountRate"
          ),
        name: "DiscountRate",
        meta: {
          name: "贴现行情",
          activeType: "06",
          url: "/DiscountRate",
          newStatus: true,
          title: "贴现行情-快贴宝"
        }
      },
      {
        path: "/BusinessTicketDiscount",
        component: r =>
          require.ensure(
            [],
            () =>
              r(
                require("@/components/businessTicketDiscount/BusinessTicketDiscount")
              ),
            "BusinessTicketDiscount"
          ),
        name: "BusinessTicketDiscount",
        meta: {
          name: "商票速融",
          activeType: "03",
          url: "/BusinessTicketDiscount",
          title: "商票速融-快贴宝"
        }
      },
      {
        path: "/Account",
        component: Account,
        redirect: "/DiscountTrends",
        meta: {
          name: "账户中心",
          activeType: "05",
          login: true,
          icon: "",
          otherIcon: "",
          list: accountRouter[0].children[0].children,
          url: "/DiscountTrends"
        }
      }
    ]
  }
];

export const redirectRouter = [
  {
    path: "/redirect/jd-piaoju",
    component: r =>
      require.ensure([], () => r(require("@/components/redirect/JdPiaojuRedirect")), "jdPiaojuRedirect"),
    meta: {
      name: "京东票据页面重定向跳转"
    }
  }
];

export const errorRouter = {
  path: "*",
  name: "Error404",
  component: r =>
    require.ensure([], () => r(require("@/components/Error404")), "error"),
  meta: {
    title: "404页面",
    isHide: true
  }
};

export const routes = [
  ...mainRouter,
  ...accountRouter,
  ...otherRouter,
  ...discountRateRouter,
  ...emptyRouter,
  ...LandingPageRouter,
  ...redirectRouter,
  errorRouter
];



// WEBPACK FOOTER //
// ./src/router/routes.js